module.exports = __webpack_public_path__ + "img/healthcare-menu-cafeteria.bd86290a.webp";